/**
 * Project enquiry: enquiry type for mailto + optional files (names in draft; user attaches in mail app).
 * Merges camera captures into the main file input via DataTransfer.
 */

function getEnquiryType(root) {
  const checked = root.querySelector('input[name="contact[Enquiry type]"]:checked');
  if (checked) return checked.value;
  const sel = root.querySelector('select[data-enquiry-type]');
  if (sel) return sel.value;
  return 'Enquiry';
}

function mergeIntoFileInput(fileInput, newFiles) {
  if (!fileInput || !newFiles?.length) return;
  const dt = new DataTransfer();
  const existing = fileInput.files ? Array.from(fileInput.files) : [];
  for (const f of existing) {
    dt.items.add(f);
  }
  for (const f of newFiles) {
    dt.items.add(f);
  }
  fileInput.files = dt.files;
}

function initProjectEnquiry(root) {
  const mailLink = root.querySelector('[data-project-enquiry-mailto]');
  const bodyField = root.querySelector('[data-enquiry-body]');
  const fileInput = root.querySelector('[data-enquiry-files]');
  const fileList = root.querySelector('[data-file-list]');
  const dropzone = root.querySelector('[data-dropzone]');
  const cameraTrigger = root.querySelector('[data-enquiry-camera-trigger]');
  const cameraInput = root.querySelector('[data-enquiry-camera-input]');
  const email = mailLink?.dataset.email || root.dataset.email;
  if (!mailLink || !email) return;

  const renderFileList = () => {
    if (!fileList || !fileInput) return;
    const files = fileInput.files ? Array.from(fileInput.files) : [];
    fileList.innerHTML = '';
    if (files.length === 0) {
      fileList.hidden = true;
      return;
    }
    fileList.hidden = false;
    for (const f of files) {
      const li = document.createElement('li');
      li.textContent = f.name;
      fileList.appendChild(li);
    }
  };

  if (fileInput && dropzone) {
    dropzone.addEventListener('click', () => {
      fileInput.click();
    });

    dropzone.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        fileInput.click();
      }
    });

    dropzone.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropzone.classList.add('is-dragover');
    });

    dropzone.addEventListener('dragleave', () => {
      dropzone.classList.remove('is-dragover');
    });

    dropzone.addEventListener('drop', (e) => {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
      if (e.dataTransfer?.files?.length) {
        mergeIntoFileInput(fileInput, Array.from(e.dataTransfer.files));
        renderFileList();
      }
    });

    fileInput.addEventListener('change', renderFileList);
  }

  if (cameraTrigger && cameraInput && fileInput) {
    cameraTrigger.addEventListener('click', () => {
      cameraInput.click();
    });
    cameraInput.addEventListener('change', () => {
      const picked = cameraInput.files ? Array.from(cameraInput.files) : [];
      if (picked.length) {
        mergeIntoFileInput(fileInput, picked);
        renderFileList();
      }
      cameraInput.value = '';
    });
  }

  const fileNamesBlock = () => {
    if (!fileInput?.files?.length) return '';
    const lines = Array.from(fileInput.files).map((f) => `• ${f.name}`);
    return `\n\nFiles to attach in your email:\n${lines.join('\n')}`;
  };

  const buildHref = () => {
    const type = getEnquiryType(root);
    const body = (bodyField?.value || '').trim();
    const defaultBody =
      body ||
      '(Add your enquiry here — attach photos or PDFs in your email before sending.)';
    const names = fileNamesBlock();
    const subject = encodeURIComponent(`Enquiry: ${type}`);
    const mailBody = encodeURIComponent(`${defaultBody}${names}\n`);
    return `mailto:${email}?subject=${subject}&body=${mailBody}`;
  };

  mailLink.addEventListener('click', () => {
    mailLink.setAttribute('href', buildHref());
  });
}

document.querySelectorAll('[data-project-enquiry]').forEach(initProjectEnquiry);
